import { render, staticRenderFns } from "./StatisticsKanban.vue?vue&type=template&id=07746544&scoped=true&"
import script from "./StatisticsKanban.vue?vue&type=script&lang=js&"
export * from "./StatisticsKanban.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsKanban.vue?vue&type=style&index=0&id=07746544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07746544",
  null
  
)

export default component.exports